import React, { Component } from 'react';

//import UnreadMessages from '../UnreadMessages';

import './NotificationArea.css';

import { observer} from 'mobx-react';

@observer
class NotificationArea extends Component {
  render() {
    return (
      <div className="NotificationArea">
        <div className="NotificationAreaContainer">
          { /*<UnreadMessages className="UnreadMessages" />*/ }
        </div>
      </div>
    );
  }
}

export default NotificationArea;
